module.exports = __webpack_public_path__ + "static/media/crdpagana.1ab14c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdpagana.png
// module id = 148
// module chunks = 0